import { Roles } from '$synapse/models';
import { Route } from '@angular/router';
import { AuthGuard } from '$synapse/core';
import { GroupsPageResolver } from './groups-resolver';
import { GroupsComponent } from './groups.component';

export const GROUPS_ROUTES: Route[] = [
  {
    path: '',
    component: GroupsComponent,
    canActivate: [AuthGuard],
    resolve: {
      page: GroupsPageResolver,
    },
    data: { roles: [Roles.MANAGER] },
    runGuardsAndResolvers: 'always',
  },
];
